import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import moment from 'moment';
import { encrypt , decrypt , getParams } from "../../../helpers/CryptoJs";
import { getlanguagelist } from "../../../helpers/changelanguage";
import { listPromotion, updatePromotion } from "../../../actions/promotionAction";
import Switch from '@material-ui/core/Switch';
import Checkbox from '@material-ui/core/Checkbox';
import { confirmAlert } from 'react-confirm-alert';
import Remainingpromotion from "./remainingpromotion"
import  "../react-confirm-alert.css";
import $ from "jquery";


class PromotionCreate extends Component {
    constructor(props) {
      super(props);
      this.state = {
       listdata  : [],
       selected  : [],
       statusSel : [], 
       chk       : false
    };
        this.onChange        = this.onChange.bind(this);
        this.createPromotion = this.createPromotion.bind(this);
        this.selectPromotion = this.selectPromotion.bind(this);
        this.deleteStatus    = this.deleteStatus.bind(this);
        this.updateStatus    = this.updateStatus.bind(this);
        this.viewMore        = this.viewMore.bind(this);
      
    }
    componentDidMount() {
        this.props.listPromotion();  
    }
    UNSAFE_componentWillReceiveProps(nextProps){   
        if(nextProps.listpromotion  != this.props.listpromotion){
            this.setState({
                listdata   : nextProps.listpromotion.promotion_list,
            })
        }
        if(nextProps.updatepromotion != this.props.updatepromotion){ 
           
            if(nextProps.updatepromotion.type == 'DELETE'){
                let list = this.state.listdata;
                this.state.selected.map((id,index)=>{
                    var removeIndex = list.map(function(obj) { return obj.id; }).indexOf(id);
                    list.splice(removeIndex, 1);
                })
            
                this.setState({
                    listdata   : list,
                    selected   : []
                })
            }else{
                let list = this.state.listdata;
                this.state.statusSel.map((id,index)=>{
                    var removeIndex = list.map(function(obj) { return obj.id; }).indexOf(id);
                    list[removeIndex].status = (list[removeIndex].status == '1') ? '0' : '1'
                })
                this.setState({
                    listdata   : list,
                    statusSel   : []
                })
            }
            
        }
    }
    createPromotion(){
        this.props.history.push(`/promotion_create`);
    }
    selectPromotion(e){
        let selected = this.state.selected;
        let selid    = e.target.name.split('_')[1];
        
        if(e.target.checked == true){
            selected.push(selid);
        }else{
            selected.pop(selid);
        }
        this.setState({
            selected : selected
        })
    }
    onChange(e) {
        this.setState({
            [e.target.name] : e.target.value,
        })
    }
    deleteStatus(type){
        let languagelist = getlanguagelist();
        if(this.state.selected.length == 0){
            alert(languagelist.selectione);
        }else{

            confirmAlert({
                title: languagelist.cofirm,
                message: languagelist.sure,
                buttons: [
                  {
                    label: languagelist.yes,
                    onClick: () => {
                        let param ={
                            promotion_id : JSON.stringify(this.state.selected),
                            update_type  : type
                        }
                        this.props.updatePromotion(param);
                    }
                  },
                  {
                    label: languagelist.no,
                    onClick: () => {
                        this.setState({
                            selected : []
                        })
                        return false;
                    }
                  }
                ]
              });
           /*  let param ={
                promotion_id : JSON.stringify(this.state.selected),
                update_type  : type
            }
            this.props.updatePromotion(param); */
        }
        
    }

    updateStatus(e){
        let curstatus = e.target.value;
        let statusSel = this.state.statusSel;
        let selid     = e.target.name.split('_')[1];
        
        statusSel.push(selid);
        this.setState({
            statusSel : statusSel
        },function(){
            let param ={
                promotion_id : JSON.stringify(this.state.statusSel),
                update_type  : 'STATUS',
                status       : (curstatus === true) ? 0 : 1 
            }
            this.props.updatePromotion(param);
        
        })

    }
    viewMore(id){
        this.props.history.push(`/promotion/${encrypt(id)}`);
    }
    render() {
        let languagelist = getlanguagelist();
        return (
            <div>
               
                <div className="content_area">
                <div className="clr20"></div>
                    <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 post_area">
                        <div className="golden_catagories_section">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>{languagelist.mypromotion}</h2>
                                </div>
                               
                                <div className="col-lg-3">
                                {
                                    ((this.state.listdata.length > 0) && (this.state.selected.length > 0))? 
                                        <a href={void(0)} className="btn_5 btn_block" onClick={()=>this.deleteStatus('DELETE')}><i className="fas fa-trash icon-size" ></i> {languagelist.remove}</a>
                                    : ''
                                }
                                </div>
                                    
                                 <div className="col-lg-3" style={{float: 'right'}}>
                                    <a href={void(0)} className="btn_5 btn_block" onClick={this.createPromotion}><i className="fa fa-plus icon-size" aria-hidden="true" ></i> {languagelist.createnew}</a>
                                </div>
                                
                            </div>



                        <div className="clr20"></div>
                        {
                            (this.state.listdata).map((row,index) => {
                                return (
                                    <div className={(index == 0  && window.location.href.includes('PROMOTION')) ? "promotions_card unread_row" : 'promotions_card'} key={`promotion_row_${index}`} id={`promotion_row_${index}`}>
                                        <ul className="row_1" >
                                            <li>
                                                <label className="custom_checkbox2">
                                                    {(row.status != 3) ?     
                                                    <Checkbox 
                                                        className="list_checkbox"
                                                        checked = 
                                                        {  (this.state.selected.indexOf(row.id) != -1) ? true : false
                                                        
                                                        }
                                                        name={`sel_${row.id}`}
                                                        value={row.id}
                                                        id={`sel_${row.id}`}
                                                        onChange={this.selectPromotion}
                                                        color="primary"
                                                    />
                                                    : null 
                                                    }
                                                </label>
                                            </li>
                                            <li><img src="/assets/images/time_icon.png" />
                                                <a href="#" className="addnew_btn">{row.remaining_days} {languagelist.dayleft} </a>
                                            </li>
                                            <li>
                                                {(row.status == 1) ? 
                                                    <span className="active_deactive"> <i className="fas fa-circle ac" aria-hidden="true"></i> {languagelist.active}</span>
                                                  : 
                                                  (row.status == 3) ? 
                                                  <span className="active_deactive"> <i className="fa fa-ban" aria-hidden="true"></i>  {languagelist.blocked}</span>
                                                  : (row.status == 2) ?
                                                    <span className="active_deactive"> <i className="fas fa-circle"></i>  {languagelist.nonpaid}</span>
                                                    :  <span className="active_deactive"> <i className="fas fa-circle"></i> {languagelist.inactive}</span>
                                                }
                                                
                                                
                                            </li>

                                            <label className="switch">  
                                            {((row.status == 1) || (row.status == 0)) ?        
                                                <Switch 
                                                    checked={(row.status == 1) ? true : false} 
                                                    onChange={this.updateStatus} 
                                                    value={(row.status == 1) ? true : false}  
                                                    color="primary"
                                                    name={`Switch_${row.id}`}
                                                    id={`Switch_${row.id}`}
                                                />
                                            : null }
                                            </label>

                                            <div className="clearfix"></div>
                                        </ul>
                                       <p className="row_2">
                                            <span className="limit_text">{row.promotion_name}</span>  
                                            <a hrefLang={void(0)} onClick={()=>this.viewMore(row.id)}>Details</a>
                                       </p>

                                        <ul className="row_3">

                                            <li>
                                                <img src="/assets/images/price_icon.png" />
                                                <a href="#" className="addnew_btn">${row.remaining_budget} {languagelist.left}</a>
                                            </li>

                                            <li>
                                                <img src="/assets/images/click_icon.png" />
                                                <a href="#" className="addnew_btn">{row.total_reach} {languagelist.click}</a>
                                            </li>

                                            <li>
                                                <img src="/assets/images/reported_icon.png" />
                                                <a href="#" className="addnew_btn">{row.no_of_report} {languagelist.reported}</a>
                                            </li>

                                            <div className="clearfix"></div>
                                        </ul>

                                    </div>
                                )
                            })
                        }
                        {
                        
                                (this.state.listdata.length == 0 ) ? 
                                <div className="notfound"><img src="/assets/images/notfound.jpg"/></div>
                                : null
                        }
                     </div>
                    </div>
                
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 right_area sidebar-item">
                        <Remainingpromotion />
                    </div>
                </div>
            </div>

        );
  }
}
const mapStateToProps = state => {
  return {
    listpromotion   : state.listpromotion.promotionList, 
    updatepromotion : state.updatepromotion.promotionUpdate, 
  }
}
const mapDispatchToProps = dispatch => {
  return {
    listPromotion  : bindActionCreators(listPromotion, dispatch),
    updatePromotion  : bindActionCreators(updatePromotion, dispatch),
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PromotionCreate));